import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Tooltip } from '@mui/material';
import { Edit, Search } from '@mui/icons-material';
import StyledActionColumnButton from 'common/theme/button/StyledActionColumnButton';
import { buildPathWithId } from 'common/utils/id';

function ActionsColumn({ actions, data = null, routes }) {
  const { t } = useTranslation();

  // `data` puede llegar vacío: sale de `getRow(data, dataIndex)[0]` y, si el índice de la tabla se
  // desincroniza de la lista (borrado, cambio de página, refetch a media carga), la fila no existe.
  // Antes se desestructuraba directo y eso reventaba con un TypeError; y si solo faltaba el id, se
  // generaba un enlace a "/algo/edit/undefined" que llevaba a una pantalla vacía sin explicación.
  const editPath = buildPathWithId(routes?.edit, data?.id);
  const viewPath = buildPathWithId(routes?.view, data?.id);

  return (
    <Box>
      {actions.includes('edit') && editPath && (
        <Link component={RouterLink} to={editPath}>
          <Tooltip title={t('edit', { ns: 'common' })}>
            <StyledActionColumnButton aria-label="edit">
              <Edit />
            </StyledActionColumnButton>
          </Tooltip>
        </Link>
      )}
      {actions.includes('view') && viewPath && (
        <Link component={RouterLink} to={viewPath}>
          <Tooltip title={t('view', { ns: 'common' })}>
            <StyledActionColumnButton aria-label="view">
              <Search />
            </StyledActionColumnButton>
          </Tooltip>
        </Link>
      )}
    </Box>
  );
}

ActionsColumn.propTypes = {
  actions: PropTypes.array.isRequired,
  data: PropTypes.object,
  routes: PropTypes.object.isRequired
};

export default ActionsColumn;
